import axiosInstance from "../../Utils/axiosInstance";
import { getLoggedInEmail } from "../../Utils/Constant";
interface PayloadForMMRfq {
    coRFQId: string;
    mmRFQId: string;
    partId: string;
}
export const getAutoPopulateCoRFQDetailsForMMRFQApi = async (
    payload: PayloadForMMRfq
) => {
    try {
        if (payload?.coRFQId && payload?.mmRFQId && payload?.partId) {
            const response = await axiosInstance.get(
                `api/sourcing_management/autoPopulateCoRFQDetailsForMMRFQ?coRFQId=${payload?.coRFQId}&mmRFQId=${payload?.mmRFQId}&partId=${payload?.partId}`
            );
            return response?.data;
        } else if (payload?.coRFQId && payload?.mmRFQId) {
            const response = await axiosInstance.get(
                `api/sourcing_management/autoPopulateCoRFQDetailsForMMRFQ?coRFQId=${payload?.coRFQId}&mmRFQId=${payload?.mmRFQId}`
            );
            return response?.data;
        } else if (payload?.coRFQId) {
            const response = await axiosInstance.get(
                `api/sourcing_management/autoPopulateCoRFQDetailsForMMRFQ?coRFQId=${payload?.coRFQId}`
            );
            return response?.data;
        }
    } catch (error) {
        return error?.response?.data;
    }
};

interface Rfq_Details {
    Customer_RFQ_Name: string;
    CORFQ_ID: string;
    // MM_RFQ_Name: string;
    Upload_Technical_Details: {
        name: string;
        size: number;
        type: string;
    };
    Compliance_Requirements: string;
    Quality_Standards: string;
    Add_Comments: string;
    Due_Date: string;
    Sourcing_Manager: string;
}
interface PartDetail {
    Part_Number: string;
    Part_Name: string;
    Solution: string[];
    Raw_Material: string;
    Target_Price: number;
    Qty_Year: string;
    Qty_Batch: string;
    UOM: string;
    Total: string;
    Type_of_Order: string;
    Mandatory_Inspection: string;
    Packing: string;
    Samples_Required: string;
    Upload_Drawing: {
        name: string;
        size: number;
        type: string;
    };
    Select_Partners: string[];
    Due_Date: string;
}
interface Payload {
    Rfq_Details: Rfq_Details;
    Part_Details: PartDetail[];
}

export const createInternalMMRfq = async (payload: Payload) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/createInternalMMRfq",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getAllMmrfq = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getInternalMMRFQs?coRFQID=${payload}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface UploadRfqPartFilePayload {
    recordId: string;
    uploadField: string;
    fileUpload: File;
}
export const uploadMMRfqPartFileAPI = async (
    payload: UploadRfqPartFilePayload
) => {
    try {
        const formData = new FormData();
        formData.append("recordId", payload.recordId);
        formData.append("uploadField", payload.uploadField);
        formData.append("fileUpload", payload.fileUpload);

        const response = await axiosInstance.post(
            "api/sourcing_management/saveFileForUploadDrawing",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Axios requires you to set this manually sometimes
                }
            }
        );

        return response?.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};

export const uploadMMRfqTechnicalFileAPI = async (
    payload: UploadRfqPartFilePayload
) => {
    try {
        const formData = new FormData();
        formData.append("recordId", payload.recordId);
        formData.append("uploadField", payload.uploadField);
        formData.append("fileUpload", payload.fileUpload);

        const response = await axiosInstance.post(
            "api/sourcing_management/saveFileForTechnicalDetails",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Axios requires you to set this manually sometimes
                }
            }
        );

        return response?.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};

interface QuoteDetails {
    Partner_Name: string;
    Packing_Charges_Unit_if_Applicable: string;
    RM_Weight: string;
    Payment_Terms: string;
    Submission_Date: string;
    Lead_time_for_Sample: string;
    Process_Cost: string;
    Quantity_Year: string;
    Part_Name: string;
    Total_Price: string;
    Lead_time_for_Complete_Production: string;
    RM_Price_Kg: string;
    RM_Grade: string;
    Finished_Weight: string;
    OH_Profit: string;
    Other_terms_conditions: string;
    Quote_Validity: string;
    Part_Number: string;
    Part_ID: string;
    MM_RFQ_ID: string;
    UOM: string;
    Final_RM_Price: string;
    Scrap_Cost: string;
    Incoterms: string;
    Transportation_Cost_Unit_if_Applicable: string;
    Unit_Price: string;
    Is_Tool_Applicable: string;
    Enter_Tool_Name: string;
    Tool_Price: string;
    Quantity: string;
    Tool_UOM: string;
    Lead_time_for_Tool: string;
    Payment_Terms_Tool: string;
    Actor: string;
    Company_RFQ: string;
}

interface Quote {
    Quote_Details: QuoteDetails[];
}

export const createInternalMMRfqQuote = async <T = any>(
    payload: Quote
): Promise<T> => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/createQuoteRecord",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const uploadFileForQuoteAttachment = async (
    payload: UploadRfqPartFilePayload
) => {
    try {
        const formData = new FormData();
        formData.append("recordId", payload.recordId);
        formData.append("uploadField", payload.uploadField);
        formData.append("fileUpload", payload.fileUpload);

        const response = await axiosInstance.post(
            "api/sourcing_management/saveFileForQuoteAttachment",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data" // Axios requires you to set this manually sometimes
                }
            }
        );

        return response?.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};
interface getQuoteParametr {
    MmPartID: string;
    MmRfqId: string;
}
export const getPartDetailsQuote = async (payload: getQuoteParametr) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getPartDetailsForQuote?MmRfqId=${payload?.MmRfqId}&MmPartID=${payload?.MmPartID}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
export const getManualQuoteData = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getQuoteDetailsByID?quoteID=${payload}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface sendReminderPayload {
    mmRfqID: string;
    Company_RFQ: string;
    Part_ID: string;
    // Partner_Name: string;
    Entity: string;
    Actor: string;
    ActorName: string;
}
export const sendReminderToSourcingHeadAPI = async (
    payload: sendReminderPayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/addNotificationWhenQuoteApprovalRequestUpdate",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

//updateInternalRFQDueDate
interface updateExtendMMRfqDatePayload {
    mmRfqID: string;
    extendedDueDate: string;
    prevDueDate: string;
}
export const updateExtendMMRfqDate = async (
    payload: updateExtendMMRfqDatePayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/updateInternalRFQDueDate",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
interface compareQuotePayload {
    mmRfqId: string;
    partId: string;
}
export const getQuoteCompareData = async (payload: compareQuotePayload) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getQuoteComparisonTable?mmRfqId=${payload?.mmRfqId}&partId=${payload?.partId}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
//updateInternalRFQPartnerList
interface updatePartnerMMRfqPayload {
    internalMMRFQPartID: string;
    addedPartnerIDs: [];
}
export const updatePartnerMMRfq = async (
    payload: updatePartnerMMRfqPayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/updateInternalRFQPartnerList",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
//api/sourcing_management/statusOfComparisionPartner
interface approvePartnerQuotesForMMRfqPayload {
    Actor: string;
    Notifier: string;
    Partner_Name: string;
    Partner_Status: string;
    MMRFQ: string;
    Quotation: string;
    Part_ID: string;
    Company_RFQ: string;
}
export const approvePartnerQuotesForMMRfq = async (
    payload: approvePartnerQuotesForMMRfqPayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/statusOfComparisionPartner",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getMmrfqDetails = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/viewMMRFQDetails?mmRfqID=${payload}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface rejectPartnerQuotesForMMRfqPayload {
    Actor: string;
    Notifier: string;
    Partner_Name: string;
    Partner_Status: string;
    Reason: string;
    MMRFQ: string;
    Quotation: string;
    Part_ID: string;
    Company_RFQ: string;
}
export const rejectPartnerQuotesForMMRfq = async (
    payload: rejectPartnerQuotesForMMRfqPayload[]
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/statusOfComparisionPartnerForRejection",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

//api/sourcing_management/sendToKamTrigger
interface sendToKamTrigger {
    coRfqID: string;
    department: string;
}
export const sendToKamTriggerAPI = async (payload: sendToKamTrigger) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/sendToKamTrigger",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

interface partnerPayload {
    MMRFQ_IDs: string[];
}
export const getSendEmailToPartnerAllMMRfq = async (
    payload: partnerPayload
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/sendEmailToPartnersMMrfq",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
interface partnerPayloadPart {
    Partners: string[];
}
export const getSendEmailToPartnerAllMMRfqPart = async (
    payload: partnerPayloadPart
) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/sendEmailToPartnersMMrfqPart",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCopoAutoPopulateData = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/general/getCopoAutopopulateData?CoRFQ_ID=${payload}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const submitCopoFormData = async (payload: any) => {
    try {
        const response = await axiosInstance.post(
            "api/key_account_management/submitCopoFormData",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

interface UploadCoPoFilePayload {
    recordId: string;
    uploadField: string;
    fileUpload: File;
}

export const uploadCoPoFileAPI = async (payload: UploadCoPoFilePayload) => {
    try {
        const formData = new FormData();
        formData.append("recordId", payload.recordId);
        formData.append("uploadField", payload.uploadField);
        formData.append("fileUpload", payload.fileUpload);

        const response = await axiosInstance.post(
            "api/key_account_management/saveCopoFile",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            }
        );

        return response?.data;
    } catch (error: any) {
        return error?.response?.data;
    }
};
